import React, { memo } from 'react'
import { usePlantBadge, PlantBadgeProps } from './usePlantBadge'
import styles from './PlantBadge.module.scss'

const PlantBadge: React.FC<PlantBadgeProps> = (props: PlantBadgeProps) => {
  const { type } = usePlantBadge(props)

  return (
    <span className={`${styles.badge} ${styles[type]}`}>
      {type === 'vegan' ? (
        <i className='bi bi-leaf me-1'></i>
      ) : (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className='me-1'
        >
          <path stroke='none' d='M0 0h24v24H0z' fill='none' />
          <path d='M3 21s9.834 -3.489 12.684 -6.34a4.487 4.487 0 0 0 0 -6.344a4.483 4.483 0 0 0 -6.342 0c-2.86 2.861 -6.347 12.689 -6.347 12.689z' />
          <path d='M9 13l-1.5 -1.5' />
          <path d='M16 14l-2 -2' />
          <path d='M22 8s-1.14 -2 -3 -2c-1.406 0 -3 2 -3 2s1.14 2 3 2s3 -2 3 -2z' />
          <path d='M16 2s-2 1.14 -2 3s2 3 2 3s2 -1.577 2 -3c0 -1.86 -2 -3 -2 -3z' />
        </svg>
      )}
      {type}
    </span>
  )
}

export default memo(PlantBadge)
